module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"pageTitle":"Ajouter un nom de domaine","btnOpenEditor":"Ajouter un nom de domaine","labelFieldDomain":"Domaine","btnCancel":"Annuler","btnAdd":"Ajouter"},"en":{"pageTitle":"Add a domain name","btnOpenEditor":"Add a domain name","labelFieldDomain":"Domain","btnCancel":"Cancel","btnAdd":"Add"}}')
  delete Component.options._Ctor
}
